export default "__VITE_ASSET__v0OF4RtA__"